var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStar = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15.155 8.57 12 2.176 8.844 8.571 1.786 9.597l5.107 4.977-1.205 7.03 6.311-3.32 6.313 3.32-1.206-7.03 5.108-4.977-7.059-1.026Zm-5.633.935L12 4.484l2.479 5.021 5.54.805-4.009 3.908.946 5.518L12 17.13l-4.956 2.606.947-5.518-4.009-3.908 5.54-.805Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStar);
export default ForwardRef;